document.addEventListener('DOMContentLoaded', (event) => {
	let ctx = document.getElementById('download-preview');

	if (ctx != null) {
		let imgTag   = ctx.querySelector('img');
		let fileList = document.querySelector('.file-list');

		if (fileList) {
			fileList.querySelectorAll('.file-list li a').forEach( (el, idx) => {
				el.addEventListener('mouseenter', (evt) => {
					let previewImg = evt.target.closest('a').dataset.preview;

					if ( (previewImg != null) && (previewImg != "") ) {
						ctx.classList.add('--loading');
						imgTag.setAttribute('src', previewImg);
						imgTag.classList.remove('--empty');
					}
				});

				el.addEventListener('mouseleave', (evt) => {
					imgTag.classList.add('--empty');
					imgTag.setAttribute('src', "");
					ctx.classList.remove('--loading');
				});
			});
		}
	}
});
